import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { FormlyDatepickerFieldConfig } from '@ngx-formly/material/datepicker';
import _moment, { default as _rollupMoment, Moment } from 'moment';
const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
    parse: {
        // dateInput: 'LL',
        // dateInput: moment.ISO_8601
    },
    display: {
        dateInput: 'MMMM DD, YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'MMMM DD, YYYY',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-form-datepicker-type',
    template: `

<input matInput
  [name]="field.key?.toString()"
  [errorStateMatcher]="errorStateMatcher"
  [formControl]="formControl"
  [matDatepicker]="picker"
  [matDatepickerFilter]="props.datepickerOptions.filter"
  (click)="picker.open()"
  [required]="field.props.required"
  [min]="field.props.datepickerOptions.min"
  [placeholder]="field.props.label"
  [formlyAttributes]="field">
  <ng-template #matSuffix>
    <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
  </ng-template>
  <mat-datepicker #picker
    [startView]="isMonthYearMode ? 'multi-year' : 'month'"
    (yearSelected)="handleDateSelection($event, 'year')"
    (monthSelected)="handleDateSelection($event, 'month', picker)"
  (closed)="onDatepickerClose()"></mat-datepicker>
  @if (field?.validators?.required) {
    <mat-error>
      {{field.props.label}} is required
    </mat-error>
  }
  @if (field?.validators?.invalidDate) {
    <mat-error>
      {{field.validation?.invalidDate?.message}}
    </mat-error>
  }

`,
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatInput, FormsModule, MatDatepickerInput, ReactiveFormsModule, FormlyModule, MatDatepickerToggle, MatDatepicker, MatError]
})
export class DatepickerTypeComponent extends FieldType<FieldTypeConfig<FormlyDatepickerFieldConfig['props'] & { isMonthYearMode?: boolean }>> implements OnInit {
    @ViewChild(MatInput) formFieldControl: MatInput;
    date = new FormControl(moment());
    isMonthYearMode = true;

    ngOnInit(): void {
        this.isMonthYearMode = this.field.props?.isMonthYearMode ?? false;
        if (this.isMonthYearMode) {
            this.field.props.datepickerOptions.min = new Date();
            MY_FORMATS.display =  {
                dateInput: 'MMMM YYYY',
                monthYearLabel: 'MMM YYYY',
                dateA11yLabel: 'LL',
                monthYearA11yLabel: 'MMMM YYYY',
            }
        }
    }

    handleDateSelection(event: Moment, type: 'year' | 'month', picker?: MatDatepicker<Moment>) {
        if (!this.isMonthYearMode) return;
        if (type === 'year') {
          this.chosenYearHandler(event);
        } else if (type === 'month') {
          this.chosenMonthHandler(event, picker);
        }
    }

    chosenYearHandler(normalizedYear: Moment) {
        const ctrlValue = this.date.value;
        ctrlValue.year(normalizedYear.year());
        ctrlValue.endOf('month');
        this.formControl.setValue(ctrlValue);
    }
    
    chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value;
        ctrlValue.month(normalizedMonth.month());
        ctrlValue.endOf('month');
        this.formControl.setValue(ctrlValue);
        datepicker.close();
    }

    onDatepickerClose() {
        if (this.isMonthYearMode && this.formControl?.value && typeof this.formControl?.value !== 'string') {
            this.formControl.setValue((this.formControl.value as Moment).endOf('month'));
        }
    }
}
